<template>
    <div>
        <x-header :left-options="{backText: ''}" >{{$t('account.credit.title')}}</x-header>
        <flexbox style="padding: 30px" orient="vertical">
            <flexbox-item>
                <x-button class="button" type="primary" link="https://www.facebook.com/精明用家熱購-2219991658079099"> Facebook Messager </x-button>
            </flexbox-item>
            <flexbox-item style="padding-top: 20px">
                <x-button class="button" type="primary" link="https://wa.me/85260775373?text=%e4%bd%a0%e5%a5%bd%ef%bc%8c%e6%88%91%e6%83%b3%e8%a9%a2%e5%95%8f%e6%9c%89%e9%97%9c%e7%94%a2%e5%93%81%e5%8f%8a%e6%9c%8d%e5%8b%99%e7%9a%84%e8%a9%b3%e6%83%85"> Whatsapp </x-button>
            </flexbox-item>
            <a style="padding: 20px; font-size: 18px; " href="tel:+852-6077 5373"> 聯絡客戶服務主任</a> 
        </flexbox>
    </div>
</template>

<script>
import { XButton, XHeader, Flexbox, FlexboxItem,} from 'vux';
export default {
    name: 'Contact',
    components: {
        XButton,
        XHeader,
        Flexbox, 
        FlexboxItem,
    }

}
</script>

<style>
.button{
    background-color: #5890DC
}
</style>




// WEBPACK FOOTER //
// src/Account/containers/Contact.vue